import React, {useEffect, useState} from "react";

import Wrapper from "../components/Wrapper";
import Sidebar from "../components/Sidebar";
import Main from "../components/Main";
import Navbar from "../components/Navbar";
import Content from "../components/Content";
import Footer from "../components/Footer";
import IdleTimeOut from "../components/IdleTimeOut";
import MFASetUpNotification from "../components/MFASetUpNotification";
import {login, logout} from "../redux/actions/userActions";
import {useDispatch} from "react-redux";
import API from "../utils/API";
import GlobalSpinner from "../components/GlobalSpinner";

const Dashboard = ({ children }) => {

    const dispatch = useDispatch();

    const [initLoading, setInitLoading] = useState(false);

    const loadUser = () => {
        API.get("/me").then(response => {
            dispatch(login(response.data.data));
            setInitLoading(true);
        });
    }

    useEffect(() => {
        const interval = setInterval(() => {
            if (!localStorage.getItem("jwt")) {
                dispatch(logout());
            }
        }, 5000);

        return () => clearInterval(interval); // This represents the unmount function, in which you need to clear your interval to prevent memory leaks.
    }, []);

    useEffect(() => {
        loadUser();

        const interval = setInterval(() => {
            loadUser();
        }, 10000);

        return () => clearInterval(interval);
    }, [])

    return <React.Fragment>
        {!initLoading ?
            <GlobalSpinner/>
            :
            <>
                <IdleTimeOut/>
                <MFASetUpNotification/>
                <Wrapper>
                    <Sidebar/>
                    <Main>
                        <Navbar/>
                        <Content>{children}</Content>
                        <Footer/>
                    </Main>
                </Wrapper>
            </>
        }
    </React.Fragment>
};

export default Dashboard;
